import styled from 'styled-components';

export const HeadingStyle = styled.p`
  font-weight: 450;
`;
